import {useState} from 'react';

import IBatchResult from './IBatchResult';

interface IUseBatchResult {
    result?: IBatchResult,
    showResult: (_result: IBatchResult) => void,
    resetResult: () => void,
}

const useBatchResult = (onShowResultChange?: (_isShowing: boolean) => void): IUseBatchResult => {
    const [result, setResult] = useState<IBatchResult | undefined>();

    const showResult = (batchResult: IBatchResult) => {
        setResult(batchResult);
        onShowResultChange?.(true);
    };

    const resetResult = () => {
        setResult(undefined);
        onShowResultChange?.(false);
    };

    return {result, showResult, resetResult};
};

export default useBatchResult;
